const SingleNumberSorted = ({ data }) => {
  console.log('SingleNumberSorted data', data);
  return data[0].value;
};

export default SingleNumberSorted;
